import React from "react"
import classNames from "classnames"
import { string, shape } from "prop-types"
import ThemeConsumer from "../ThemeConsumer"

const Textarea = (props) => {
  const { theme, preset, placeholder, ...rest } = props

  const classes = classNames({ [theme[preset]]: preset })

  return <textarea {...rest} placeholder={placeholder} className={classes} />
}

Textarea.propTypes = {
  preset: string,
  placeholder: string,
  theme: shape({
    preset: string
  })
}

Textarea.defaultProps = {
  theme: {},
  placeholder: "",
  preset: "normal"
}

export default ThemeConsumer("UITextarea")(Textarea)



// WEBPACK FOOTER //
// ./src/shared/components/TextArea/index.js